import { useToast } from 'components/common/custom-toast/Toast';
import React, {useState, useEffect} from 'react';


const NoInternetConnection = (props) => {
    const toast = useToast()
    // state variable holds the state of the internet connection
    const [isOnline, setOnline] = useState(true);

    // On initization set the isOnline state.
    useEffect(()=>{
        setOnline(navigator.onLine)
    },[])

    window.addEventListener('online', () => {
       // setOnline(true)
        toast.success('Your internet connection has been restored');
        return;
    },{once : true});

    window.addEventListener('offline', () => {
        // setOnline(false)
        toast.error('No internet Connection. Please refresh page!');
            return;
    },{once : true});

    if(isOnline) {
        return(<></>);
    } else {
        return(<></>);
    }
}

export default NoInternetConnection;